module.exports = __webpack_public_path__ + "img/primary-logo-white.2b492d1b.svg";